import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import {
  Typography,
  Stack,
  Box,
  Button,
  InputAdornment,
  TextField,
  Select,
  FormControl,
  MenuItem,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
} from "@mui/material";
import moment from "moment";
import { useQuery } from "@apollo/client";

// icon
import CheckIcon from "@mui/icons-material/Check";

// Style
import "../../../../Style/pageStyle.scss";

// src
import { AuthContext } from "../../../../Context/AuthContext";
import { translateLauguage } from "../../../../Function/Translate";
import EmptyData from "../../../../Components/Include/EmptyData";
import LoadingPage from "../../../../Components/Include/LoadingPage";
import SelectDatePicker from "../../../Include/SelecteDatePicker/SelectDatePicker";
import { GET_STUDENT_ATTENDENCE_BY_STUDENT_ID } from "../../../../Schema/Attendance";

export default function StudentAttendance({ editData, stuId }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [dateVal, setDateVal] = useState(moment());
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  var daysInMonth = [];
  var monthDate = moment(dateVal)?.startOf("month");

  for (let i = 0; i < monthDate.daysInMonth(); i++) {
    let newDay = monthDate.clone().add(i, "days");
    let dayWithSuffix = newDay;
    daysInMonth.push(dayWithSuffix);
  }
  const monthValue = moment.months();

  const { refetch } = useQuery(GET_STUDENT_ATTENDENCE_BY_STUDENT_ID, {
    variables: {
      stuId: stuId,
      from: moment(dateVal).startOf("month").format("YYYY-MM-DD"),
      to: moment(dateVal).endOf("month").format("YYYY-MM-DD"),
    },
    onCompleted: ({ getStudentAttendanceByStudentId }) => {
      setTableData(getStudentAttendanceByStudentId);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [dateVal]);

  console.log("tableData", tableData);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`date`)}
            </Typography>
            <SelectDatePicker
              inputFormat="MMMM"
              format="MMMM"
              views={["month"]}
              date={dateVal}
              setDate={(e) => setDateVal(e)}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px`, whiteSpace: "nowrap" }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_student_id")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_name")}
                </TableCell>
                {daysInMonth?.map((day, index) => {
                  return (
                    <TableCell
                      key={index}
                      className={
                        language === "en" ? "header-title" : "header-title-kh"
                      }
                    >
                      {moment(day).format("DD")}
                    </TableCell>
                  );
                })}
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                  align="center"
                >
                  {t("presence")}
                </TableCell>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                  align="center"
                >
                  {t("percentage")}
                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={40} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell
                    className={
                      language === "en"
                        ? "body-cell-start"
                        : "body-cell-start-kh"
                    }
                  >
                    {editData?.student_id}
                  </TableCell>
                  <TableCell
                    className={language === "en" ? "body-cell" : "body-cell-kh"}
                  >
                    {language === "en"
                      ? editData?.full_name_latin
                      : editData?.full_name_kh}
                  </TableCell>

                  {tableData?.days?.map((att, index) => {
                    return (
                      <TableCell
                        key={index}
                        className={
                          language === "en" ? "body-cell" : "body-cell-kh"
                        }
                      >
                        {att?.attendance_status === "Presence" ? (
                          <CheckIcon
                            style={{
                              width: "22px",
                              height: "auto",
                              color: "#158843",
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </TableCell>
                    );
                  })}

                  <TableCell
                    className={language === "en" ? "body-cell" : "body-cell-kh"}
                    align="center"
                  >
                    {tableData?.totalPresence}
                  </TableCell>

                  <TableCell
                    className={
                      language === "en" ? "body-cell-end" : "body-cell-end-kh"
                    }
                    align="center"
                  >
                    {tableData?.totalPercentage} %
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
